import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface IMerchantIdField {
	settingsId: string;
	onChange: (value: string) => void;
}

const MerchantIdField: React.FC<IMerchantIdField> = ({ onChange, settingsId }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterMerchantId') }], [t]);

	return (
		<FormInput
			testId="MerchantIdField"
			name={`merchantId-${settingsId}`}
			label="merchantIdLabel"
			onChange={onChange}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(MerchantIdField);
